import { gql } from '@apollo/client';

export const UPDATE_ACCOUNT_BALANCE_STATS = gql`
  mutation updateProgram($input: ProgramInput) {
    updateProgram(input: $input) {
      program {
        id
      }
    }
  }
`;
